var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('a',{attrs:{"href":"/#"}},[_c('img',{attrs:{"src":"/img/waves-punks.svg"}}),_vm._v(" SOLD OUT ")]),_c('a',{attrs:{"href":"/zombie"}},[_c('img',{attrs:{"src":"/img/waves-punks-zombie.svg"}}),_vm._v(" FOR SALE ")]),_c('a',{attrs:{"href":"/mad-empire"}},[_c('img',{attrs:{"src":"/img/waves-mad-punks.svg"}}),_vm._v(" FOR SALE ")])])
}]

export { render, staticRenderFns }